/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MediaItemDto
 */
export interface MediaItemDto {
    /**
     *
     * @type {number}
     * @memberof MediaItemDto
     */
    mediaItemId?: number;
    /**
     * The org this media belongs to.
     * @type {string}
     * @memberof MediaItemDto
     */
    organisationId?: string;
    /**
     * Full url to the file, including access token.
     * @type {string}
     * @memberof MediaItemDto
     */
    url?: string;
    /**
     * filename excluding path. Required.
     * @type {string}
     * @memberof MediaItemDto
     */
    filename?: string;
    /**
     * File size. Required.
     * @type {number}
     * @memberof MediaItemDto
     */
    sizeBytes?: number;
    /**
     * Standard content type eg image/jpeg. Currently images, text, and pdfs are allowed. Required.
     * @type {string}
     * @memberof MediaItemDto
     */
    contentType?: string;
    /**
     * Category may be used to distinguish site maps from charger photos, etc. Required.
     * @type {string}
     * @memberof MediaItemDto
     */
    category?: MediaItemDtoCategoryEnum;
    /**
     * optional user supplied name.
     * @type {string}
     * @memberof MediaItemDto
     */
    name?: string;
    /**
     * optional user supplied description.
     * @type {string}
     * @memberof MediaItemDto
     */
    description?: string;
    /**
     * The user that uploaded the media
     * @type {number}
     * @memberof MediaItemDto
     */
    createdByUserAccountId?: number;
    /**
     *
     * @type {Date}
     * @memberof MediaItemDto
     */
    createdAt?: Date;
}

/**
 * @export
 */
export const MediaItemDtoCategoryEnum = {
    Unknown: "Unknown",
    SiteMap: "SiteMap",
    DevicePhoto: "DevicePhoto",
} as const;
export type MediaItemDtoCategoryEnum =
    (typeof MediaItemDtoCategoryEnum)[keyof typeof MediaItemDtoCategoryEnum];

/**
 * Check if a given object implements the MediaItemDto interface.
 */
export function instanceOfMediaItemDto(value: object): value is MediaItemDto {
    return true;
}

export function MediaItemDtoFromJSON(json: any): MediaItemDto {
    return MediaItemDtoFromJSONTyped(json, false);
}

export function MediaItemDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): MediaItemDto {
    if (json == null) {
        return json;
    }
    return {
        mediaItemId:
            json["mediaItemId"] == null ? undefined : json["mediaItemId"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        url: json["url"] == null ? undefined : json["url"],
        filename: json["filename"] == null ? undefined : json["filename"],
        sizeBytes: json["sizeBytes"] == null ? undefined : json["sizeBytes"],
        contentType:
            json["contentType"] == null ? undefined : json["contentType"],
        category: json["category"] == null ? undefined : json["category"],
        name: json["name"] == null ? undefined : json["name"],
        description:
            json["description"] == null ? undefined : json["description"],
        createdByUserAccountId:
            json["createdByUserAccountId"] == null
                ? undefined
                : json["createdByUserAccountId"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
    };
}

export function MediaItemDtoToJSON(value?: MediaItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        mediaItemId: value["mediaItemId"],
        organisationId: value["organisationId"],
        url: value["url"],
        filename: value["filename"],
        sizeBytes: value["sizeBytes"],
        contentType: value["contentType"],
        category: value["category"],
        name: value["name"],
        description: value["description"],
        createdByUserAccountId: value["createdByUserAccountId"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
    };
}
